module.exports = __webpack_public_path__ + "img/sharepoint.66dc75cb.png";